import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import {
  faMagnifyingGlass,
  faIndent,
  faImages,
  faTable,
  faInfo,
  faBrain,
  faCertificate,
  faComment,
  faFilePen,
  faNotesMedical,
  faUserDoctor,
  faUser,
  faBookmark,
  faTriangleExclamation,
  faQuoteLeft,
  faExclamation,
  faArrowRightToBracket,
  faBook,
  faPills,
  faDisease,
  faSuperscript,
  faSubscript,
  faUpload,
  faPlusCircle,
  faCircleExclamation,
  faCodeCompare,
  faEdit,
  faPenToSquare,
  faNoteSticky,
  faTrashCan,
  faForward,
  faBackward,
  faMaximize,
  faMinimize,
  faCircleInfo,
  faPaperPlane,
  faLink,
  faStopCircle,
  faPlayCircle,
  faTrash,
  faSpinner,
  faLayerGroup,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faArrowsTurnToDots,
  faTurnDown,
  faHouse,
  faPlus,
  faBullhorn,
  faSlash,
  faSort,
  faFilter,
  faSliders,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import {
  faBookmark as farBookmark,
  faFile as farFile,
  faFileAudio as farFileAudio,
  faFileVideo as farFileVideo,
  faCopy as farCopy,
} from '@fortawesome/free-regular-svg-icons'

let iconsRegistered = false

const registerIcons = () => {
  if (iconsRegistered) {
    return
  }

  library.add(
    faMagnifyingGlass,
    faIndent,
    faImages,
    faTable,
    faInfo,
    faBrain,
    faCertificate,
    faComment,
    faFilePen,
    faNotesMedical,
    faUserDoctor,
    faUser,
    faBookmark,
    farBookmark,
    faTriangleExclamation,
    faQuoteLeft,
    faExclamation,
    faArrowRightToBracket,
    faBook,
    faPills,
    faDisease,
    faSuperscript,
    faSubscript,
    faUpload,
    faPenToSquare,
    faNoteSticky,
    faPlusCircle,
    faCircleExclamation,
    faCodeCompare,
    faEdit,
    faTrashCan,
    farFile,
    farFileAudio,
    farFileVideo,
    faForward,
    faBackward,
    faMaximize,
    faMinimize,
    faCircleInfo,
    faPaperPlane,
    faLink,
    faStopCircle,
    faPlayCircle,
    faTrash,
    faSpinner,
    faSliders,
    faLayerGroup,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faArrowsTurnToDots,
    faTurnDown,
    faHouse,
    faPlus,
    faBullhorn,
    faSlash,
    faSort,
    faFilter,
    farCopy,
    faXmark
  )

  iconsRegistered = true
}

export const installFontAwesome = (app) => {
  registerIcons()

  app.component('fa-icon', FontAwesomeIcon)
  app.component('fa-layers', FontAwesomeLayers)
  app.component('fa-layers-text', FontAwesomeLayersText)
}
